import { useQuery } from "@tanstack/react-query";
import { httpClient } from "@coworker/http-client";

interface ItemStockInfo {
  available: number;
  elevated: number | null;
}

async function fetchItemStockInfo(itemType: string, itemNo: string) {
  return await httpClient.tasks.get<ItemStockInfo>(
    `/items/item-stock?itemNo=${itemNo}&itemType=${itemType}`
  );
}

export function useItemStock(itemType: string, itemNo: string) {
  return useQuery({
    queryKey: ["item", "stock", itemType, itemNo],
    queryFn: async () => await fetchItemStockInfo(itemType, itemNo),
    staleTime: 86400000, // 1 day, considered fresh for a day.
    refetchOnWindowFocus: false,
    enabled: !!itemNo && !!itemType,
  });
}
